import { useParams } from 'react-router-dom';
import { Card, Spin, Divider, Typography } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import RoomAdForm from '../components/RoomAdForm';
import AdImageManager from '../components/AdImageManager';
import ImportedSourceCard from '../components/ImportedSourceCard';
import { useRoomAdDetails } from '../hooks/useRoomAdDetails';
import { useUpdateRoomAd } from '../hooks/useRoomAdMutations';

export default function RoomAdEditPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails, refetch } = useRoomAdDetails(id);
  const mutation = useUpdateRoomAd();

  const handleSubmit = (formData: any) => {
    (mutation.mutate as any)({ id, data: formData });
  };

  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <PageHeader back title={t('roomAds.editTitle')} subtitle={`${t('common.editing')}: #${id} ${data?.title || ''}`} />

      {/* If this ad was imported from a third-party source (Roomaty, etc.), show the
          rich source card first — that's what the operator most wants to see. */}
      {data?.importSource && (
        <ImportedSourceCard
          importSource={data.importSource}
          importSourceId={data.importSourceId}
          importSourceUrl={data.importSourceUrl}
          importedAt={data.importedAt}
          importedByAdminId={data.importedByAdminId}
          sourceMetadata={data.sourceMetadata}
        />
      )}

      <Card style={{ marginTop: 16 }}>
        <RoomAdForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>

      <Card style={{ marginTop: 16 }}>
        <Typography.Title level={5} style={{ marginTop: 0 }}>{t('roomAds.images.sectionTitle')}</Typography.Title>
        <Divider style={{ margin: '8px 0 16px' }} />
        {id && <AdImageManager adId={id} onChange={() => refetch()} />}
      </Card>
    </div>
  );
}
